import { useLazyQuery } from "@apollo/client";
import { clientNeoCurrencyExchange } from "@neonumy/api-clients";
import { LIST_CURRENCIES } from "queries/neoCurrency";
import { useMemo, useEffect } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";

export default function useListCurrencies() {
  const [listCurrencies, { data: currencies, error: listCurrenciesError }] =
    useLazyQuery<ListCurrenciesResponse>(LIST_CURRENCIES, {
      client: clientNeoCurrencyExchange,
    });

  useEffect(() => {
    if (listCurrenciesError) onErrorGraphql(listCurrenciesError);
  }, [listCurrenciesError]);

  const currenciesOptions = useMemo(() => {
    if (!currencies) return undefined;

    const options =
      currencies?.listCurrencies?.map((currency: { currency: string; name: string }) => ({
        label: `${currency.name} (${currency.currency})`,
        value: currency.currency,
      })) || [];

    const eurIndex = options.findIndex(
      (option: { label: string; value: string }) => option.value === "EUR",
    );
    if (eurIndex > 0) {
      const eurOption = options.splice(eurIndex, 1)[0];
      options.unshift(eurOption);
    }

    return options;
  }, [currencies]);

  return { listCurrencies, currenciesOptions };
}
